import React from "react";
import "./nestedReply.css";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { IP } from "./../../../../internalServer"

const NestedReply = ({ parentReply }) => {
  function shortenParagraph(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength).trim() + '...';
  }
  return (
    <>
      <>
        {/*nested Reply ui*/}
        <div className=" p-1 gap-1 flex-wrap nested_reply_box ml-4">
          <div className=" gap-1 d-flex align-items-center">
            {/* {console.log("parentReply", parentReply)} */}
            {
              parentReply?.createdBy?.role === "Teacher" ? (
                <img
                  src={
                    parentReply?.createdBy?.profile_picture
                      ? IP + parentReply?.createdBy?.profile_picture.replace(/^\./, "")
                      : parentReply?.createdBy?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : parentReply?.createdBy?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default-profile.png"
                  }
                  alt='icon'
                  className="profilePicImg"
                  style={{ width: "25px", height: "25px", borderRadius: "50%" }}
                  onError={(e) => {
                    // This function will run if the image fails to load
                    if (parentReply?.createdBy?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg";
                    } else if (parentReply?.createdBy?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png";
                    } else {
                      e.target.src = "/images/default-profile.png"
                    }
                  }}
                />
              ) : (
                <img
                  src={
                    parentReply?.createdBy?.profile_picture
                      ? IP + parentReply?.createdBy?.profile_picture.replace(/^\./, "")
                      : parentReply?.createdBy?.gender === "M"
                        ? parentReply?.createdBy?.avatarProfile ? '/images/Boys/' + parentReply?.createdBy?.avatarProfile + '.webp'
                          : "/images/Student_boy_pic.png"
                        : parentReply?.createdBy?.gender === "F"
                          ? parentReply?.createdBy?.avatarProfile ? '/images/Girls/' + parentReply?.createdBy?.avatarProfile + '.webp'
                            : "/images/Student_girl_pic.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className="prifilePicImg"
                  key={parentReply?.createdBy?.avatarProfile}
                  style={{ width: "25px", height: "25px", borderRadius: "50%" }}
                  onError={(e) => {
                    if (parentReply?.createdBy?.gender === "M") {
                      // console.log("insie if")
                      e.target.src = parentReply?.createdBy?.avatarProfile ? '/images/Boys/' + parentReply?.createdBy?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                    } else if (parentReply?.createdBy.gender === "F") {
                      e.target.src = parentReply?.createdBy?.avatarProfile ? '/images/Girls/' + parentReply?.createdBy?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                />
              )
            }
            <span className=" nested_user_name">
              {parentReply.createdBy.name}
            </span>
            <span className=" ms-2 nested_reply_time">
              {moment(parentReply.created_at).calendar({
                sameDay: "h:mm A",
                lastDay: "[Yesterday]",
                lastWeek: "DD MMM YYYY ",
                sameElse: "DD MMM YYYY",
              })}
            </span>
          </div>
          <p className="comments-text poppins-semibold mb-0 mt-1"
            style={{ whiteSpace: "pre-wrap", width: "96%" }}
          >
            {parentReply.reply}
          </p>
        </div>
      </>
    </>
  );
};

export default NestedReply;
